(ns teamoesterreich.user-mode.location.location-create
  (:require
    [clojure.string]                                        ;;(h/event-value e)
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.cancel :refer [cancel]]
    [reagent-material-ui.icons.home :refer [home]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.save :refer [save]]

    [reagent-material-ui.icons.search :refer [search]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.map.map-picker :as map-picker]


    [teamoesterreich.user-mode.navigation.bottom-bar :as bottom-bar]
    [teamoesterreich.user-mode.ui-helper.are-you-sure-modal :as ays-modal]
    [teamoesterreich.util.helper :as h]
    [teamoesterreich.util.log :as log]))

(def googleGeoCoder (js/google.maps.Geocoder.))


(defn addressComponents-parse [comp]
  (let [struct (reduce
                 (fn [c e]
                   (log/out e)
                   (merge c
                          (case (first (get-in e ["types"]))
                            "postal_code" [:zip (get e "long_name")]
                            "locality" [:city (get e "long_name")]
                            "street_number" [:streetNo (get e "long_name")]
                            "route" [:street (get e "long_name")]
                            nil
                            ))

                   ) {} (js->clj comp))]
    (assoc struct :address (str (:zip struct) " " (:city struct) " " (:street struct) " " (:streetNo struct)))
    ))


(defn geo-revers-lookup [lat lng cb-fn]
  (log/out "geo-revers-lookup" lat lng googleGeoCoder)
  (.geocode googleGeoCoder
            #js {:location (js/google.maps.LatLng. lat lng)}
            (fn [result status]
              (log/out "geo-revers-lookup " (first (js->clj result)) status)
              (when (= status "OK")
                (cb-fn (addressComponents-parse (get (first (js->clj result)) "address_components")))
                ))))

(defn select-option [!map]
  [mui/grid
   {:container  true
    :direction  "row"
    :justify    "center"
    :alignItems "center"
    :spacing    2

    }
   [mui/grid {:item true
              :xs   4
              }
    [mui/button {:onClick #(swap! !map assoc :pickMode (not (:pickMode @!map)))
                 :variant "outlined"
                 :title   "Auf der Karte auf deinen Standort klicken"
                 :color   "primary"}
     "Kartenauswahl aktivieren"]]

   [mui/grid {:item true
              :xs   4
              }
    [mui/typography {:style {:padding "7px 0 0 10px"}} " oder "]]

   [mui/grid {:container false :item true
              :xs        4
              }
    [mui/button {:onClick #(swap! !map assoc :searchMode (not (:searchMode @!map)))
                 :variant "outlined"
                 :color   "primary"}
     "Adresse suchen"]]
   ]

  )

(defn lookup-address-option [!map !location-form]
  [mui/grid
   {:container  true
    :direction  "row"
    :justify    "center"
    :alignItems "center"
    :spacing    2

    }

   [mui/grid {:container false :item true
              :xs        4
              }
    [mui/button {:color   "default"
                 :variant "outlined"
                 :onClick #(swap! !map assoc :map-x nil :map-y nil :pickMode false)
                 }
     "Zurück"]]

   [mui/grid {:item true
              :xs   4
              }
    [mui/button {:variant "outlined"
                 :color   "primary"
                 :onClick (fn [] (geo-revers-lookup (:map-x @!map) (:map-y @!map)
                                                    (fn [address]
                                                      (swap! !location-form assoc
                                                             :address (:address address)
                                                             :name (:address address)
                                                             :street (:street address)
                                                             :streetNo (:streetNo address)
                                                             :zip (:zip address)
                                                             :city (:city address)
                                                             ))))
                 }
     "Adresse ermitteln"]]

   ]

  )

(defn auto-complete [!map]
  (r/create-class
    {:reagent-render       (fn []
                             [mui/text-field
                              {
                               :id          "google-Autocomplete"
                               :placeholder "Adressensuche..."
                               :fullWidth   true
                               :multiline   false}])
     :component-did-mount  (fn [comp]
                             (let [auto-complete (js/google.maps.places.Autocomplete.
                                                   (.getElementById js/document "google-Autocomplete")
                                                   #js {:componentRestrictions #js {:country (txt/txt :core :map_country)}})]
                               (js/google.maps.event.addListener auto-complete "place_changed"
                                                                 (fn [p]
                                                                   (let [place (.getPlace auto-complete)]
                                                                     (log/out "address search " place))))
                               (swap! !map assoc :autoCompleteObj auto-complete)

                               ))
     :component-did-update (fn [params])

     :display-name         "gmap-autocomplete"}))




(defn address-option [!map !location-form]
  (let [!map-ac (r/cursor !map [:autoCompleteObj])
        ]
    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "center"
      :alignItems "center"
      :spacing    2

      }
     [mui/grid {:item true
                :md   5
                :xs   12
                }
      [auto-complete !map]
      ]
     [mui/grid {:item  true
                :md    3
                :xs    6
                :style {:paddingLeft "5px"}
                }

      [mui/button
       {:variant "outlined"
        :color   "primary"
        :style   {:minWidth "140px"}
        :onClick (fn []
                   (log/out "Suche Adresse " @!map-ac)
                   (when-let [ac @!map-ac]
                     (when-let [place (.getPlace ^js ac)]
                       (when-let [geo (.-geometry place)]
                         (let [
                               lat (.lat (.-location geo))
                               lng (.lng (.-location geo))
                               address (addressComponents-parse (.-address_components place))
                               ]
                           (log/out "Suche Adresse " lat lng address)
                           (swap! !map assoc
                                  :map-x lat
                                  :map-y lng
                                  :center true
                                  )
                           (swap! !location-form assoc
                                  :address (:address address)
                                  :name (:address address)
                                  :street (:street address)
                                  :streetNo (:streetNo address)
                                  :zip (:zip address)
                                  :city (:city address)
                                  )

                           )))))
        }
       [search]
       "Suchen"
       ]]
     [mui/grid {:item  true
                :md    3
                :xs    6
                :style {:paddingLeft "5px"}
                }
      [mui/button
       {:variant "outlined"
        :style   {:minWidth "140px"}
        :onClick (fn []
                   (set! (. (.getElementById js/document "google-Autocomplete") -value))
                   (swap! !map assoc
                          :map-x nil
                          :map-y nil
                          :searchMode false
                          ))
        }
       [cancel]
       "Abbrechen"
       ]

      ]

     ]

    ))

(defn address-create-part [continue-fn]
  (let [!st (r/atom {:location-form {}})
        !map (r/cursor !st [:map])
        !location-form (r/cursor !st [:location-form])
        save-fn (fn []
                  (log/out "save form")
                  (a/create-location {:coordinates         (js/firebase.firestore.GeoPoint. (:map-x @!map) (:map-y @!map))
                                      :name                (str (get-in @!location-form [:name]))
                                      :address             (str (get-in @!location-form [:address]))
                                      :street              (str (get-in @!location-form [:street]))
                                      :streetNo            (str (get-in @!location-form [:streetNo]))
                                      :zip                 (str (get-in @!location-form [:zip]))
                                      :city                (str (get-in @!location-form [:city]))


                                      :preparation-enabled true}
                                     (fn [locationId]       ;success-fn
                                       (continue-fn)
                                       )))
        ]
    (fn []
      (let [f-name (or (get-in @!location-form [:name]) "")
            f-name-ch (and (get-in @!location-form [:name]) (not= (get-in @!location-form [:name]) ""))

            f-address (or (get-in @!location-form [:address]) "")
            f-address-ch (and (get-in @!location-form [:address]) (not= (get-in @!location-form [:address]) ""))

            f-streetNo (or (get-in @!location-form [:streetNo]) "")
            f-streetNo-ch (and (get-in @!location-form [:streetNo]) (not= (get-in @!location-form [:streetNo]) ""))

            change-fn (fn [key] (fn [e]
                                  (log/out "Change " key "-> " (h/event-value e))
                                  (swap! !location-form assoc-in key (h/event-value e))
                                  (swap! !location-form assoc :address (str (:zip @!location-form) " " (:city @!location-form) " " (:street @!location-form) " " (:streetNo @!location-form)))))

            do-save? (and
                       f-name-ch
                       f-address-ch
                       f-streetNo-ch
                       )]
        [:div
         [map-picker/pick-place !map]
         [:br]
         (cond
           ;select option
           (not (or
                  (and @!map (:searchMode @!map))
                  (and @!map (:addressMode @!map))
                  (and @!map (:pickMode @!map))
                  (and @!map (:map-x @!map))))
           (select-option !map)

           ;map-pick option
           (or (and @!map (:pickMode @!map)))
           [mui/typography "Bitte klicke in der Karte"]

           ;lookup address after pick
           (and @!map (:map-x @!map) (not (:searchMode @!map)) (not (:address @!location-form)))
           (lookup-address-option !map !location-form)


           (and (:searchMode @!map) (not (:map-x @!map)))
           (address-option !map !location-form)

           :else
           [mui/button
            {:variant "outlined"
             :style   {:minWidth "200px"}
             :onClick (fn []
                        (swap! !map assoc
                               :map-x nil
                               :map-y nil
                               :searchMode false
                               :pickMode false
                               )
                        (swap! !location-form assoc
                               :address nil
                               ))
             }
            [cancel]
            "Zurücksetzen"
            ]

           )

         [mui/grid
          {:container  true
           :direction  "row"
           :justify    "flex-start"
           :alignItems "flex-start"
           :style      {:marginTop "15px"}

           }

          ;; address
          ;[mui/grid
          ; {:container false :item true
          ;  :md        12  ;medium: 960px
          ;  :xs        12  ;extra-small: 0px
          ;  :style     {}
          ;  }
          ;
          ; [mui/text-field {
          ;                  :fullWidth    true
          ;                  :value (or f-address "")
          ;                  :InputLabelProps {:disableAnimation true :shrink true}
          ;                  :disabled true
          ;                  :label        "Ermittelte Adresse"}]
          ;
          ; ]

          [mui/grid
           {:container false :item true
            :xl        4                                    ;medium: 960px
            :xs        8                                    ;extra-small: 0px
            :style     {}
            }

           [mui/text-field {
                            :fullWidth       true
                            :value           (:street @!location-form)
                            :InputLabelProps {:disableAnimation true :shrink true}
                            :disabled        true
                            :label           "Straße"}]]
          [mui/grid
           {:container false :item true
            :xl        2                                    ;medium: 960px
            :xs        4                                    ;extra-small: 0px
            :style     {}
            }
           [mui/text-field {
                            :style           #js {:backgroundColor (if (or (= "" f-streetNo) f-streetNo-ch) "#ffd6d2" "#ffffff")}
                            :fullWidth       true
                            :defaultValue    (or f-streetNo "")
                            :InputLabelProps {:disableAnimation true :shrink true}
                            :onChange        (change-fn [:streetNo])
                            :label           "Haus-Nummer / Stiege / Stock / Tür"}]]
          [mui/grid
           {:container false :item true
            :xl        2                                    ;medium: 960px
            :xs        4                                    ;extra-small: 0px
            :style     {}
            }
           [mui/text-field {
                            :fullWidth       true
                            :value           (:zip @!location-form)
                            :InputLabelProps {:disableAnimation true :shrink true}
                            :disabled        true
                            :label           "Plz"}]]
          [mui/grid
           {:container false :item true
            :xl        4                                    ;medium: 960px
            :xs        8                                    ;extra-small: 0px
            :style     {}
            }
           [mui/text-field {
                            :fullWidth       true
                            :value           (:city @!location-form)
                            :InputLabelProps {:disableAnimation true :shrink true}
                            :disabled        true
                            :label           "Ort"}]

           ]



          [mui/grid
           {:container false :item true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:marginTop "5px"}
            }
           [mui/text-field {
                            :style           #js {:backgroundColor (if f-name-ch "#ffd6d2" "#ffffff")}
                            :fullWidth       true
                            :defaultValue    (or f-name "")
                            :InputLabelProps {:disableAnimation true :shrink true}
                            :helperText      (if (> (count f-name) 0) "Hier kannst du noch den Standortnamen ändern" "")
                            :onChange        (change-fn [:name])
                            :label           "Standort Name"}]

           ]





          [mui/grid
           {:container false
            :item      true
            :xs        12
            :style     {:marginTop "20px"}
            }
           [mui/button
            {:variant   "contained"
             :color     "primary"
             :class     "bottom-button"
             :disabled  (not do-save?)

             :startIcon (r/as-element [save])
             :style     {:float "right"}
             :onClick   save-fn
             }
            "Anlegen"]

           ]
          ]
         ])
      )))

(defn get-it []
  (log/out "init location form")
  (let [!st (r/atom {:location-form {}})
        !map (r/cursor !st [:map])
        !location-form (r/cursor !st [:location-form])
        !lose-data-modal (r/cursor !st [:location-form :show-lose-data-form-modal])
        !actual-location (r/cursor store/app-state [:state :selected-location])]
    (fn []
      (let [
            f-name (or (get-in @!location-form [:name]) "")
            f-name-ch (and (get-in @!location-form [:name]) (not= (get-in @!location-form [:name]) ""))

            f-address (or (get-in @!location-form [:address]) "")
            f-address-ch (and (get-in @!location-form [:address]) (not= (get-in @!location-form [:address]) ""))

            f-streetNo (or (get-in @!location-form [:streetNo]) "")
            f-streetNo-ch (and (get-in @!location-form [:streetNo]) (not= (get-in @!location-form [:streetNo]) ""))



            do-save? (and
                       f-name-ch
                       f-address-ch
                       f-streetNo-ch
                       )



            save-fn (fn []
                      (log/out "save form")
                      (a/create-location {:coordinates         (js/firebase.firestore.GeoPoint. (:map-x @!map) (:map-y @!map))
                                          :name                (str (get-in @!location-form [:name]))
                                          :address             (str (get-in @!location-form [:address]))
                                          :street              (str (get-in @!location-form [:street]))
                                          :streetNo            (str (get-in @!location-form [:streetNo]))
                                          :zip                 (str (get-in @!location-form [:zip]))
                                          :city                (str (get-in @!location-form [:city]))


                                          :preparation-enabled true}
                                         (fn [locationId]   ;success-fn
                                           (reset! !actual-location locationId)
                                           (.scrollTo js/window 0 0)
                                           (case (:site @store/app-state)
                                             :warning-locationCreate (a/set-page :warning-locationForm)
                                             :prevent-locationCreate (a/set-page :prevent-locationForm)
                                             (a/set-page :profile-personal-location-form)
                                             )
                                           )))

            change-fn (fn [key] (fn [e]
                                  (log/out "Change " key "-> " (h/event-value e))
                                  (swap! !location-form assoc-in key (h/event-value e))
                                  (swap! !location-form assoc :address (str (:zip @!location-form) " " (:city @!location-form) " " (:street @!location-form) " " (:streetNo @!location-form)))))

            real-back-fn (fn []
                           (.scrollTo js/window 0 0)
                           (a/set-page-back))

            back-fn (fn [_]
                      (log/out "back-fn called")
                      (if (or
                            f-name-ch
                            f-address-ch
                            )
                        (reset! !lose-data-modal true)
                        (real-back-fn)
                        ))

            ]
        (log/out "redraw form" @!location-form @!map)
        (bottom-bar/set-actions back-fn (when do-save? save-fn))

        [mui/grid
         {:container  true
          :direction  "column"
          :justify    "center"
          :alignItems "center"
          :spacing    2

          }

         [mui/grid
          {:container false :item true
           :md        6                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           }
          [mui/card {:class ""
                     :style {:textAlign "left"}}
           [ays-modal/are-you-sure-modal !lose-data-modal "Dieses Formular hat nicht gespeicherte Daten. Willst du es wirklich schließen?" "Eingabe verwerfen"
            real-back-fn]


           [mui/card-content
            [mui/grid
             {:container  true
              :direction  "row"
              :justify    "space-between"
              :alignItems "flex-start"
              :spacing    0
              }
             [mui/grid
              {:container false :item true
               :xs        12                                ;extra-small: 0px
               }
              [:h1 [home] " Neuen Standort anlegen"]
              ]

             [mui/grid
              {:container false :item true
               :xs        12                                ;extra-small: 0px
               :style     {:marginBottom "15px"}
               }
              [map-picker/pick-place !map]
              ]



             [mui/grid
              {:item true
               :xs   12
               }
              (cond
                ;select option
                (not (or
                       (and @!map (:searchMode @!map))
                       (and @!map (:addressMode @!map))
                       (and @!map (:pickMode @!map))
                       (and @!map (:map-x @!map))))
                (select-option !map)

                ;map-pick option
                (or (and @!map (:pickMode @!map)))
                [mui/typography "Bitte klicke in der Karte"]

                ;lookup address after pick
                (and @!map (:map-x @!map) (not (:searchMode @!map)) (not (:address @!location-form)))
                (lookup-address-option !map !location-form)


                (and (:searchMode @!map) (not (:map-x @!map)))
                (address-option !map !location-form)

                :else
                [mui/button
                 {:variant "outlined"
                  :style   {:minWidth "200px"}
                  :onClick (fn []
                             (swap! !map assoc
                                    :map-x nil
                                    :map-y nil
                                    :searchMode false
                                    :pickMode false
                                    )
                             (swap! !location-form assoc
                                    :address nil
                                    ))
                  }
                 [cancel]
                 "Zurücksetzen"
                 ]

                )]








             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "flex-start"
               :alignItems "flex-start"
               :style      {:marginTop "15px"}

               }

              ;; address
              ;[mui/grid
              ; {:container false :item true
              ;  :md        12  ;medium: 960px
              ;  :xs        12  ;extra-small: 0px
              ;  :style     {}
              ;  }
              ;
              ; [mui/text-field {
              ;                  :fullWidth    true
              ;                  :value (or f-address "")
              ;                  :InputLabelProps {:disableAnimation true :shrink true}
              ;                  :disabled true
              ;                  :label        "Ermittelte Adresse"}]
              ;
              ; ]

              [mui/grid
               {:container false :item true
                :xl        4                                ;medium: 960px
                :xs        8                                ;extra-small: 0px
                :style     {}
                }

               [mui/text-field {
                                :fullWidth       true
                                :value           (:street @!location-form)
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :disabled        true
                                :label           "Straße"}]]
              [mui/grid
               {:container false :item true
                :xl        2                                ;medium: 960px
                :xs        4                                ;extra-small: 0px
                :style     {}
                }
               [mui/text-field {
                                :style           #js {:backgroundColor (if f-streetNo-ch "#ffd6d2" "#ffffff")}
                                :fullWidth       true
                                :defaultValue    (or f-streetNo "")
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :onChange        (change-fn [:streetNo])
                                :label           "Haus-Nummer / Stiege / Stock / Tür"}]]
              [mui/grid
               {:container false :item true
                :xl        2                                ;medium: 960px
                :xs        4                                ;extra-small: 0px
                :style     {}
                }
               [mui/text-field {
                                :fullWidth       true
                                :value           (:zip @!location-form)
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :disabled        true
                                :label           "Plz"}]]
              [mui/grid
               {:container false :item true
                :xl        4                                ;medium: 960px
                :xs        8                                ;extra-small: 0px
                :style     {}
                }
               [mui/text-field {
                                :fullWidth       true
                                :value           (:city @!location-form)
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :disabled        true
                                :label           "Ort"}]

               ]



              [mui/grid
               {:container false :item true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     {:marginTop "5px"}
                }
               [mui/text-field {
                                :style           #js {:backgroundColor (if f-name-ch "#ffd6d2" "#ffffff")}
                                :fullWidth       true
                                :defaultValue    (or f-name "")
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :helperText      (if (> (count f-name) 0) "Hier kannst du noch den Standortnamen ändern" "")
                                :onChange        (change-fn [:name])
                                :label           "Standort Name"}]

               ]





              [mui/grid
               {:container false
                :item      true
                :xs        12
                :style     {:marginTop "20px"}
                }
               [mui/button
                {:variant   "contained"
                 :class     "bottom-button"

                 :onClick   back-fn
                 :startIcon (r/as-element [keyboard-arrow-left])
                 }
                "Zurück"]
               [mui/button
                {:variant   "contained"
                 :color     "primary"
                 :class     "bottom-button"
                 :disabled  (not do-save?)

                 :startIcon (r/as-element [save])
                 :style     {:float "right"}
                 :onClick   save-fn
                 }
                "Anlegen"]

               ]

              ]

             ]

            ]

           ]]]
        ))))






